"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4787],{

/***/ 3735:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Tz": function() { return /* binding */ AutoColumn; },
/* harmony export */   "lg": function() { return /* binding */ ColumnCenter; },
/* harmony export */   "sg": function() { return /* binding */ Column; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _pancakeswap_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5199);




var Column = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_ui__WEBPACK_IMPORTED_MODULE_1__/* .AtomBox */ .p, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start"
    }, props));
};
var AutoColumn = function(_param) /*#__PURE__*/ {
    var gap = _param.gap, justify = _param.justify, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "gap",
        "justify"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_ui__WEBPACK_IMPORTED_MODULE_1__/* .AtomBox */ .p, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        display: "grid",
        gridAutoRows: "auto",
        justifyItems: justify,
        rowGap: gap
    }, props));
};
var ColumnCenter = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Column, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        width: "full",
        alignItems: "center"
    }, props));
};


/***/ }),

/***/ 72963:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ QuestionHelper; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26297);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52322);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98813);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(13670);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(78933);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19453);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  :hover,\n  :focus {\n    opacity: 0.7;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var QuestionWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-35be06be-0"
})(_templateObject());
var QuestionHelper = function(_param) {
    var text = _param.text, _placement = _param.placement, placement = _placement === void 0 ? "right-end" : _placement, _size = _param.size, size = _size === void 0 ? "16px" : _size, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "text",
        "placement",
        "size"
    ]);
    var ref = (0,_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(text, {
        placement: placement
    }), targetRef = ref.targetRef, tooltip = ref.tooltip, tooltipVisible = ref.tooltipVisible;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, props), {
        children: [
            tooltipVisible && tooltip,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(QuestionWrapper, {
                ref: targetRef,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    color: "textSubtle",
                    width: size
                })
            })
        ]
    }));
};


/***/ }),

/***/ 92372:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BA": function() { return /* binding */ AutoRow; },
/* harmony export */   "DA": function() { return /* binding */ RowFixed; },
/* harmony export */   "X2": function() { return /* binding */ Row; },
/* harmony export */   "m0": function() { return /* binding */ RowBetween; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _pancakeswap_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5199);




var Row = function(_param) /*#__PURE__*/ {
    var _width = _param.width, width = _width === void 0 ? "100%" : _width, _alignItems = _param.alignItems, alignItems = _alignItems === void 0 ? "center" : _alignItems, _justifyContent = _param.justifyContent, justifyContent = _justifyContent === void 0 ? "flex-start" : _justifyContent, _padding = _param.padding, padding = _padding === void 0 ? "0" : _padding, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "width",
        "alignItems",
        "justifyContent",
        "padding"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pancakeswap_ui__WEBPACK_IMPORTED_MODULE_2__/* .AtomBox */ .p, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        display: "flex",
        width: width,
        alignItems: alignItems,
        justifyContent: justifyContent,
        padding: padding
    }, props));
};
var AutoRow = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Row, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        flexWrap: "wrap"
    }, props));
};
var RowFixed = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Row, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        width: "fit",
        flexWrap: "wrap"
    }, props));
};
var RowBetween = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Row, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        flexWrap: "wrap",
        justifyContent: "space-between"
    }, props));
};


/***/ }),

/***/ 10669:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96670);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62923);





var Icon = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M16 17.01V11c0-.55-.45-1-1-1s-1 .45-1 1v6.01h-1.79c-.45 0-.67.54-.35.85l2.79 2.78c.2.19.51.19.71 0l2.79-2.78c.32-.31.09-.85-.35-.85H16zM8.65 3.35L5.86 6.14c-.32.31-.1.85.35.85H8V13c0 .55.45 1 1 1s1-.45 1-1V6.99h1.79c.45 0 .67-.54.35-.85L9.35 3.35a.501.501 0 00-.7 0z"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 83611:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96670);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62923);





var Icon = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 96 96"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                cx: "48",
                cy: "48",
                r: "48",
                fill: "#F0B90B"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M30.9008 25.9057L47.8088 16.0637L64.7169 25.9057L58.5007 29.5416L47.8088 23.3355L37.117 29.5416L30.9008 25.9057ZM64.7169 38.3179L58.5007 34.682L47.8088 40.8881L37.117 34.682L30.9008 38.3179V45.5897L41.5926 51.7958V64.2079L47.8088 67.8438L54.0251 64.2079V51.7958L64.7169 45.5897V38.3179ZM64.7169 58.0018V50.7301L58.5007 54.366V61.6377L64.7169 58.0018ZM69.1305 60.572L58.4386 66.7781V74.0499L75.3467 64.2079V44.524L69.1305 48.1599V60.572ZM62.9143 32.1118L69.1305 35.7477V43.0195L75.3467 39.3836V32.1118L69.1305 28.4759L62.9143 32.1118ZM41.5926 69.411V76.6828L47.8088 80.3187L54.0251 76.6828V69.411L47.8088 73.0469L41.5926 69.411ZM30.9008 58.0018L37.117 61.6377V54.366L30.9008 50.7301V58.0018ZM41.5926 32.1118L47.8088 35.7477L54.0251 32.1118L47.8088 28.4759L41.5926 32.1118ZM26.4872 35.7477L32.7034 32.1118L26.4872 28.4759L20.271 32.1118V39.3836L26.4872 43.0195V35.7477ZM26.4872 48.1599L20.271 44.524V64.2079L37.1791 74.0499V66.7781L26.4872 60.572V48.1599Z",
                fill: "white"
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 46178:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96670);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62923);





var Icon = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M13.8909522,2.57142857 L14.1855951,4.61428571 L14.3034522,5.45892857 L15.0695236,5.8125 C15.3838094,5.96964286 15.7177379,6.14642857 16.0123808,6.34285714 L16.6998808,6.79464286 L17.4659522,6.5 L19.4695236,5.71428571 L21.3355951,8.8375 L19.6855951,10.0946429 L18.9980951,10.625 L19.0766665,11.4892857 C19.0963094,11.6660714 19.0963094,11.8428571 19.0963094,12 C19.0963094,12.1571429 19.0963094,12.3339286 19.0766665,12.5107143 L18.9980951,13.375 L19.6855951,13.9053571 L21.3355951,15.1625 L19.4891665,18.2857143 L17.4659522,17.5 L16.6998808,17.2053571 L16.0123808,17.6571429 C15.6980951,17.8732143 15.3838094,18.05 15.0695236,18.1875 L14.3034522,18.5410714 L14.1855951,19.3660714 L13.8909522,21.4285714 L10.1195236,21.4285714 L9.82488078,19.3857143 L9.70702364,18.5410714 L8.94095221,18.1875 C8.6266665,18.0303571 8.29273792,17.8535714 7.99809507,17.6571429 L7.31059507,17.2053571 L6.54452364,17.5 L4.54095221,18.2857143 L2.67488078,15.1625 L4.32488078,13.9053571 L5.01238078,13.375 L4.93380935,12.5107143 C4.9141665,12.3339286 4.9141665,12.1571429 4.9141665,12 C4.9141665,11.8428571 4.9141665,11.6660714 4.93380935,11.4892857 L5.01238078,10.625 L4.32488078,10.0946429 L2.67488078,8.8375 L4.52130935,5.71428571 L6.54452364,6.5 L7.31059507,6.79464286 L7.99809507,6.34285714 C8.31238078,6.12678571 8.6266665,5.95 8.94095221,5.8125 L9.70702364,5.45892857 L9.82488078,4.63392857 L10.1195236,2.57142857 L13.8909522,2.57142857 M14.1070236,1 L9.90345221,1 C9.23559507,1 8.68559507,1.47142857 8.58738078,2.1 L8.27309507,4.37857143 C7.88023792,4.55535714 7.50702364,4.77142857 7.1141665,5.02678571 L4.89452364,4.1625 C4.73738078,4.10357143 4.58023792,4.08392857 4.42309507,4.08392857 C3.9516665,4.08392857 3.49988078,4.31964286 3.28380935,4.73214286 L1.18202364,8.26785714 C0.848095068,8.81785714 0.985595068,9.54464286 1.49630935,9.9375 L3.36238078,11.3517857 C3.34273792,11.5875 3.32309507,11.8035714 3.32309507,12 C3.32309507,12.1964286 3.32309507,12.4125 3.36238078,12.6482143 L1.49630935,14.0625 C0.985595068,14.4553571 0.848095068,15.1428571 1.18202364,15.7321429 L3.2641665,19.2482143 C3.49988078,19.6607143 3.9516665,19.9160714 4.42309507,19.9160714 C4.58023792,19.9160714 4.71773792,19.8964286 4.87488078,19.8375 L7.09452364,18.9732143 C7.46773792,19.2285714 7.86059507,19.4446429 8.25345221,19.6214286 L8.58738078,21.8803571 C8.66595221,22.5089286 9.23559507,23 9.90345221,23 L14.1070236,23 C14.7748808,23 15.3248808,22.5285714 15.4230951,21.9 L15.7570236,19.6214286 C16.1498808,19.4446429 16.5230951,19.2285714 16.9159522,18.9732143 L19.1355951,19.8375 C19.2927379,19.8964286 19.4498808,19.9160714 19.6070236,19.9160714 C20.0784522,19.9160714 20.5302379,19.6803571 20.7463094,19.2678571 L22.8480951,15.7125 C23.1623808,15.1428571 23.0248808,14.4553571 22.5141665,14.0625 L20.6480951,12.6482143 C20.6677379,12.4517857 20.6873808,12.2357143 20.6873808,12 C20.6873808,11.7642857 20.6677379,11.5482143 20.6480951,11.3517857 L22.5141665,9.9375 C23.0248808,9.54464286 23.1623808,8.85714286 22.8284522,8.26785714 L20.7463094,4.75178571 C20.5105951,4.33928571 20.0588094,4.08392857 19.5873808,4.08392857 C19.4302379,4.08392857 19.2927379,4.10357143 19.1355951,4.1625 L16.9159522,5.02678571 C16.5427379,4.77142857 16.1498808,4.55535714 15.7570236,4.37857143 L15.4230951,2.11964286 C15.3248808,1.47142857 14.7748808,1 14.1070236,1 Z M12.0052379,8.85714286 C13.7338094,8.85714286 15.1480951,10.2714286 15.1480951,12 C15.1480951,13.7285714 13.7338094,15.1428571 12.0052379,15.1428571 C10.2766665,15.1428571 8.86238078,13.7285714 8.86238078,12 C8.86238078,10.2714286 10.2766665,8.85714286 12.0052379,8.85714286 M12.0052379,7.28571429 C9.41238078,7.28571429 7.29095221,9.40714286 7.29095221,12 C7.29095221,14.5928571 9.41238078,16.7142857 12.0052379,16.7142857 C14.5980951,16.7142857 16.7195236,14.5928571 16.7195236,12 C16.7195236,9.40714286 14.5980951,7.28571429 12.0052379,7.28571429 Z",
            id: "形状",
            fill: "#444444",
            fillRule: "nonzero"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 35:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96670);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62923);





var Icon = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M3.0238306,6.00033181 C6.36396751,1.58805219 12.7143513,0.689101759 17.1719908,3.98800241 C18.5740236,5.02303249 19.6750317,6.40444714 20.3719244,7.97554858 L20.3719244,7.97554858 L20.9657266,6.30960374 C21.1059298,5.90961205 21.5471578,5.69930713 21.9471495,5.84363403 C22.3471412,5.98796094 22.5533225,6.42918891 22.4131192,6.83742782 L22.4131192,6.83742782 L21.0275809,10.7136361 C20.916243,11.0270317 20.619342,11.2249657 20.3018228,11.2249657 C20.2729574,11.2249657 20.1737173,11.2159576 20.1613464,11.2159576 C20.0425568,11.1843262 19.8581543,11.0962524 19.8141247,11.0004833 C19.6796663,10.6077658 19.4779787,10.0186895 19.2090619,9.23325444 C18.6523724,7.64565851 17.6255896,6.2395021 16.2524222,5.22509015 C12.4628101,2.42102459 7.07735477,3.18801901 4.24854745,6.92814762 C2.87950367,8.73429575 2.30219605,10.95693 2.62383887,13.1878116 C2.94548169,15.4310641 4.13308593,17.4145281 5.96809942,18.771201 C9.75358794,21.5752665 15.1431669,20.8123958 17.9760978,17.0722671 C18.7183504,16.0949678 19.2255564,14.9980834 19.4853449,13.8146028 C19.5760646,13.3981165 19.9884272,13.1383281 20.4007898,13.2290479 C20.8131524,13.3197677 21.0770644,13.7280066 20.9863447,14.1444928 C20.6770727,15.5465256 20.079147,16.8413441 19.2008147,18.000083 C17.2173507,20.6185854 14.1782385,22 11.09789,22 C8.99071717,22 6.86704987,21.3484671 5.0526545,20.0082887 C2.88775094,18.4041983 1.48159453,16.0578552 1.10222096,13.4063638 C0.722847388,10.7672433 1.40736927,8.13636998 3.0238306,6.00033181 Z M11.2070386,6.07559297 C11.6212522,6.07559297 11.9570386,6.41137941 11.9570386,6.82559297 L11.9570386,11.325593 C11.9570386,11.4573161 11.9230809,11.5811079 11.8634421,11.6886919 C11.8199281,11.8861494 11.6964197,12.0649766 11.5075195,12.1740381 L6.74437982,14.9240381 C6.38566035,15.1311449 5.92696754,15.0082385 5.71986076,14.6495191 C5.51275398,14.2907996 5.63566035,13.8321068 5.99437982,13.625 L10.457,11.048 L10.4570386,6.82559297 C10.4570386,6.41137941 10.792825,6.07559297 11.2070386,6.07559297 Z",
            id: "形状结合",
            fill: "#444444",
            fillRule: "nonzero",
            transform: "translate(11.728519, 12.000000) scale(-1, 1) translate(-11.728519, -12.000000) "
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 6814:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96670);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62923);





var Icon = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M4.1534 13.6089L4.15362 13.61C4.77322 16.8113 7.42207 19.3677 10.647 19.8853L10.6502 19.8858C13.0412 20.2736 15.2625 19.6103 16.9422 18.2833C11.3549 16.2878 7.9748 10.3524 9.26266 4.48816C5.69846 5.77194 3.35817 9.51245 4.1534 13.6089ZM10.0083 2.21054C4.76622 3.2533 1.09895 8.36947 2.19006 13.9901C2.97006 18.0201 6.28006 21.2101 10.3301 21.8601C13.8512 22.4311 17.0955 21.1608 19.2662 18.8587C19.2765 18.8478 19.2866 18.837 19.2968 18.8261C19.4385 18.6745 19.5757 18.5184 19.7079 18.3581C19.7105 18.355 19.713 18.3519 19.7156 18.3487C19.8853 18.1426 20.0469 17.9295 20.2001 17.7101C20.4101 17.4001 20.2401 16.9601 19.8701 16.9201C19.5114 16.8796 19.1602 16.8209 18.817 16.7452C18.7964 16.7406 18.7758 16.736 18.7552 16.7313C18.6676 16.7114 18.5804 16.6903 18.4938 16.6681C18.4919 16.6676 18.4901 16.6672 18.4882 16.6667C13.0234 15.2647 9.72516 9.48006 11.4542 4.03417C11.4549 4.03214 11.4555 4.03012 11.4562 4.0281C11.4875 3.92954 11.5205 3.83109 11.5552 3.73278C11.5565 3.72911 11.5578 3.72543 11.5591 3.72175C11.6768 3.38921 11.8136 3.05829 11.9701 2.73005C12.1301 2.39005 11.8501 2.01005 11.4701 2.03005C11.1954 2.04379 10.924 2.06848 10.6561 2.10368C10.6517 2.10427 10.6472 2.10486 10.6428 2.10545C10.4413 2.13221 10.2418 2.16492 10.0446 2.2034C10.0325 2.20576 10.0204 2.20814 10.0083 2.21054Z"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 68056:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96670);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62923);





var Icon = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M5.66 4.2L6.05 4.59C6.44 4.97 6.44 5.61 6.05 5.99L6.04 6C5.65 6.39 5.03 6.39 4.64 6L4.25 5.61C3.86 5.23 3.86 4.6 4.25 4.21L4.26 4.2C4.64 3.82 5.27 3.81 5.66 4.2Z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M1.99 10.95H3.01C3.56 10.95 4 11.39 4 11.95V11.96C4 12.51 3.56 12.95 3 12.94H1.99C1.44 12.94 1 12.5 1 11.95V11.94C1 11.39 1.44 10.95 1.99 10.95Z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M12 1H12.01C12.56 1 13 1.44 13 1.99V2.96C13 3.51 12.56 3.95 12 3.94H11.99C11.44 3.94 11 3.5 11 2.95V1.99C11 1.44 11.44 1 12 1Z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M18.34 4.2C18.73 3.82 19.36 3.82 19.75 4.21C20.14 4.6 20.14 5.22 19.75 5.61L19.36 6C18.98 6.39 18.35 6.39 17.96 6L17.95 5.99C17.56 5.61 17.56 4.98 17.95 4.59L18.34 4.2Z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M18.33 19.7L17.94 19.31C17.55 18.92 17.55 18.3 17.95 17.9C18.33 17.52 18.96 17.51 19.35 17.9L19.74 18.29C20.13 18.68 20.13 19.31 19.74 19.7C19.35 20.09 18.72 20.09 18.33 19.7Z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M20 11.95V11.94C20 11.39 20.44 10.95 20.99 10.95H22C22.55 10.95 22.99 11.39 22.99 11.94V11.95C22.99 12.5 22.55 12.94 22 12.94H20.99C20.44 12.94 20 12.5 20 11.95Z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6 11.95C6 8.64 8.69 5.95 12 5.95C15.31 5.95 18 8.64 18 11.95C18 15.26 15.31 17.95 12 17.95C8.69 17.95 6 15.26 6 11.95ZM12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M12 22.9H11.99C11.44 22.9 11 22.46 11 21.91V20.95C11 20.4 11.44 19.96 11.99 19.96H12C12.55 19.96 12.99 20.4 12.99 20.95V21.91C12.99 22.46 12.55 22.9 12 22.9Z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M5.66 19.69C5.27 20.08 4.64 20.08 4.25 19.69C3.86 19.3 3.86 18.68 4.24 18.28L4.63 17.89C5.02 17.5 5.65 17.5 6.04 17.89L6.05 17.9C6.43 18.28 6.44 18.91 6.05 19.3L5.66 19.69Z"
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Icon);


/***/ }),

/***/ 65649:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68056);
/* harmony import */ var _Svg__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6814);
/* harmony import */ var _Toggle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46098);




var ThemeSwitcher = function(param) {
    var isDark = param.isDark, toggleTheme = param.toggleTheme;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Toggle__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        checked: isDark,
        defaultColor: "textDisabled",
        checkedColor: "textDisabled",
        onChange: function() {
            return toggleTheme(!isDark);
        },
        scale: "md",
        startIcon: function() {
            var isActive = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                color: isActive ? "warning" : "backgroundAlt"
            });
        },
        endIcon: function() {
            var isActive = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Svg__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                color: isActive ? "secondary" : "backgroundAlt"
            });
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(ThemeSwitcher, function(prev, next) {
    return prev.isDark === next.isDark;
}));


/***/ }),

/***/ 46098:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Toggle_Toggle; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(76903);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19453);
;// CONCATENATED MODULE: ../../packages/uikit/src/components/Toggle/types.ts
var scales = {
    SM: "sm",
    MD: "md",
    LG: "lg"
};
var scaleKeys = {
    handleHeight: "handleHeight",
    handleWidth: "handleWidth",
    handleLeft: "handleLeft",
    handleTop: "handleTop",
    checkedLeft: "checkedLeft",
    toggleHeight: "toggleHeight",
    toggleWidth: "toggleWidth"
};

;// CONCATENATED MODULE: ../../packages/uikit/src/components/Toggle/StyledToggle.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n  border-radius: 50%;\n  cursor: pointer;\n  height: ",
        ";\n  left: ",
        ";\n  position: absolute;\n  top: ",
        ";\n  transition: left 200ms ease-in;\n  width: ",
        ";\n  z-index: 1;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  opacity: 0;\n  height: 100%;\n  position: absolute;\n  width: 100%;\n  z-index: 3;\n\n  &:checked + ",
        " {\n    left: ",
        ";\n  }\n\n  &:focus + ",
        " {\n    box-shadow: ",
        ";\n  }\n\n  &:hover + ",
        ":not(:disabled):not(:checked) {\n    box-shadow: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  background-color: ",
        ";\n  border-radius: 18px;\n  box-shadow: ",
        ";\n  cursor: pointer;\n  display: inline-flex;\n  height: ",
        ";\n  position: relative;\n  transition: background-color 200ms;\n  width: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var scaleKeyValues = {
    sm: {
        handleHeight: "16px",
        handleWidth: "16px",
        handleLeft: "2px",
        handleTop: "2px",
        checkedLeft: "calc(100% - 18px)",
        toggleHeight: "20px",
        toggleWidth: "36px"
    },
    md: {
        handleHeight: "26px",
        handleWidth: "26px",
        handleLeft: "3px",
        handleTop: "3px",
        checkedLeft: "calc(100% - 30px)",
        toggleHeight: "32px",
        toggleWidth: "56px"
    },
    lg: {
        handleHeight: "32px",
        handleWidth: "32px",
        handleLeft: "4px",
        handleTop: "4px",
        checkedLeft: "calc(100% - 36px)",
        toggleHeight: "40px",
        toggleWidth: "72px"
    }
};
var getScale = function(property) {
    return function(param) {
        var _scale = param.scale, scale = _scale === void 0 ? scales.LG : _scale;
        return scaleKeyValues[scale][property];
    };
};
var Handle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5c5a9070-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.toggle.handleBackground;
}, getScale("handleHeight"), getScale("handleLeft"), getScale("handleTop"), getScale("handleWidth"));
var Input = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    componentId: "sc-5c5a9070-1"
})(_templateObject1(), Handle, getScale("checkedLeft"), Handle, function(param) {
    var theme = param.theme;
    return theme.shadows.focus;
}, Handle, function(param) {
    var theme = param.theme;
    return theme.shadows.focus;
});
var StyledToggle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5c5a9070-2"
})(_templateObject2(), function(param) {
    var theme = param.theme, $checked = param.$checked, $checkedColor = param.$checkedColor, $defaultColor = param.$defaultColor;
    return theme.colors[$checked ? $checkedColor : $defaultColor];
}, function(param) {
    var theme = param.theme;
    return theme.shadows.inset;
}, getScale("toggleHeight"), getScale("toggleWidth"));
/* harmony default export */ var Toggle_StyledToggle = (StyledToggle);

;// CONCATENATED MODULE: ../../packages/uikit/src/components/Toggle/Toggle.tsx








var Toggle = function(_param) {
    var checked = _param.checked, _defaultColor = _param.defaultColor, defaultColor = _defaultColor === void 0 ? "input" : _defaultColor, _checkedColor = _param.checkedColor, checkedColor = _checkedColor === void 0 ? "success" : _checkedColor, _scale = _param.scale, scale = _scale === void 0 ? scales.LG : _scale, startIcon = _param.startIcon, endIcon = _param.endIcon, props = (0,_object_without_properties/* default */.Z)(_param, [
        "checked",
        "defaultColor",
        "checkedColor",
        "scale",
        "startIcon",
        "endIcon"
    ]);
    var isChecked = !!checked;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Toggle_StyledToggle, {
        $checked: isChecked,
        $checkedColor: checkedColor,
        $defaultColor: defaultColor,
        scale: scale,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                checked: checked,
                scale: scale
            }, props), {
                type: "checkbox"
            })),
            startIcon && endIcon ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Handle, {
                        scale: scale,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                            height: "100%",
                            alignItems: "center",
                            justifyContent: "center",
                            children: checked ? endIcon(checked) : startIcon(!checked)
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        width: "100%",
                        height: "100%",
                        justifyContent: "space-around",
                        alignItems: "center",
                        children: [
                            startIcon(),
                            endIcon()
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Handle, {
                scale: scale
            })
        ]
    });
};
/* harmony default export */ var Toggle_Toggle = (Toggle);


/***/ }),

/***/ 39625:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H": function() { return /* binding */ Swap; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Button/IconButton.tsx
var IconButton = __webpack_require__(93058);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Svg/Icons/ArrowDown.tsx
var ArrowDown = __webpack_require__(52180);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Svg/Icons/ArrowUpDown.tsx
var ArrowUpDown = __webpack_require__(10669);
// EXTERNAL MODULE: ../../packages/uikit/src/widgets/Swap/SwapWidget.css.ts
var SwapWidget_css = __webpack_require__(15578);
// EXTERNAL MODULE: ../../packages/ui/components/AtomBox.tsx + 6 modules
var AtomBox = __webpack_require__(5199);
// EXTERNAL MODULE: ../../packages/uikit/src/widgets/Swap/NumericalInput.tsx + 1 modules
var NumericalInput = __webpack_require__(38934);
;// CONCATENATED MODULE: ../../packages/uikit/src/widgets/Swap/CurrencyInputPanel.tsx




function CurrencyInputPanel(param) {
    var value = param.value, onUserInput = param.onUserInput, onInputBlur = param.onInputBlur, zapStyle = param.zapStyle, top = param.top, bottom = param.bottom, id = param.id, disabled = param.disabled, error = param.error;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AtomBox/* AtomBox */.p, {
        position: "relative",
        id: id,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AtomBox/* AtomBox */.p, {
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                children: top
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(AtomBox/* AtomBox */.p, {
                display: "flex",
                flexDirection: "column",
                flexWrap: "nowrap",
                position: "relative",
                backgroundColor: "backgroundAlt",
                zIndex: "1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(AtomBox/* AtomBox */.p, {
                        as: "label",
                        className: (0,SwapWidget_css/* inputContainerVariants */.U7)({
                            hasZapStyle: !!zapStyle,
                            error: error
                        }),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AtomBox/* AtomBox */.p, {
                                display: "flex",
                                flexDirection: "row",
                                flexWrap: "nowrap",
                                color: "text",
                                fontSize: "12px",
                                lineHeight: "16px",
                                px: "16px",
                                pt: "12px",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NumericalInput/* NumericalInput */.$, {
                                    error: error,
                                    disabled: disabled,
                                    className: "token-amount-input",
                                    value: value,
                                    onBlur: onInputBlur,
                                    onUserInput: function(val) {
                                        onUserInput(val);
                                    }
                                })
                            }),
                            bottom
                        ]
                    }),
                    disabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(AtomBox/* AtomBox */.p, {
                        role: "presentation",
                        position: "absolute",
                        inset: "0",
                        backgroundColor: "backgroundAlt",
                        opacity: "0.6"
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ../../packages/uikit/src/components/Heading/Heading.tsx + 1 modules
var Heading = __webpack_require__(48497);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(89495);
;// CONCATENATED MODULE: ../../packages/uikit/src/widgets/Swap/CurrencyInputHeader.tsx




var CurrencyInputHeader = function(param) {
    var title = param.title, subtitle = param.subtitle;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AtomBox/* AtomBox */.p, {
        width: "full",
        alignItems: "center",
        flexDirection: "column",
        padding: "24px",
        borderBottom: "1",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AtomBox/* AtomBox */.p, {
                display: "flex",
                width: "full",
                alignItems: "center",
                justifyContent: "space-between",
                children: title
            }),
            subtitle
        ]
    });
};
var CurrencyInputHeaderTitle = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
        as: "h2",
        children: children
    });
};
var CurrencyInputHeaderSubTitle = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
        color: "textSubtle",
        fontSize: "14px",
        children: children
    });
};

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19453);
// EXTERNAL MODULE: ../../packages/localization/src/index.tsx + 6 modules
var src = __webpack_require__(65957);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(76903);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Image/Image.tsx
var Image = __webpack_require__(96469);
;// CONCATENATED MODULE: ../../packages/uikit/src/widgets/Swap/Footer.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: ",
        ";\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n  align-items: center;\n  padding-top: 16px;\n  padding-right: ",
        ";\n  ",
        " {\n    justify-content: space-between;\n    flex-direction: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  svg {\n    fill: ",
        ";\n    transition: background-color 0.2s, opacity 0.2s;\n  }\n  &:hover {\n    svg {\n      opacity: 0.65;\n    }\n  }\n  &:active {\n    svg {\n      opacity: 0.85;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-74862ee8-0"
})(_templateObject(), function(param) {
    var $isSide = param.$isSide;
    return $isSide ? "100%" : "auto";
}, function(param) {
    var $isSide = param.$isSide;
    return $isSide ? "32px" : "0px";
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.md;
}, function(param) {
    var $isSide = param.$isSide;
    return $isSide ? "column" : "row";
});
var BubbleWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-74862ee8-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.textSubtle;
});
var Footer = function(param) {
    var _variant = param.variant, variant = _variant === void 0 ? "default" : _variant, helpUrl = param.helpUrl, _helpImage = param.helpImage, helpImage = _helpImage === void 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
        src: "https://www.maplesales.org/images/logo.png",
        alt: "Maple",
        width: 50,
        height: 50
    }) : _helpImage, _isEvm = param.isEvm, isEvm = _isEvm === void 0 ? true : _isEvm;
    var t = (0,src/* useTranslation */.$G)().t;
    var isSide = variant === "side";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        $isSide: isSide,
        className: "footer",
        children: [
            isSide && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                flexGrow: 1
            }),
            helpUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                flexGrow: isSide ? 0 : 1,
                alignItems: "center",
                width: [
                    "100%",
                    "100%",
                    "100%",
                    isSide ? "100%" : "auto"
                ],
                justifyContent: [
                    "center",
                    "center",
                    "center",
                    "flex-end"
                ]
            })
        ]
    });
};
var SwapFooter = /*#__PURE__*/ (0,react.memo)(Footer);

;// CONCATENATED MODULE: ../../packages/uikit/src/widgets/Swap/Page.tsx







var SwapPage = function(_param) /*#__PURE__*/ {
    var removePadding = _param.removePadding, noMinHeight = _param.noMinHeight, children = _param.children, hideFooterOnDesktop = _param.hideFooterOnDesktop, helpUrl = _param.helpUrl, isEvm = _param.isEvm, helpImage = _param.helpImage, props = (0,_object_without_properties/* default */.Z)(_param, [
        "removePadding",
        "noMinHeight",
        "children",
        "hideFooterOnDesktop",
        "helpUrl",
        "isEvm",
        "helpImage"
    ]);
    return (0,jsx_runtime.jsxs)(AtomBox/* AtomBox */.p, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: (0,SwapWidget_css/* pageVariants */.wz)({
            removePadding: removePadding,
            noMinHeight: noMinHeight
        })
    }, props), {
        children: [
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AtomBox/* AtomBox */.p, {
                display: "flex",
                flexGrow: 1
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AtomBox/* AtomBox */.p, {
                display: [
                    "block",
                    null,
                    null,
                    hideFooterOnDesktop ? "none" : "block"
                ],
                width: "100%",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapFooter, {
                    isEvm: isEvm,
                    helpUrl: helpUrl,
                    helpImage: helpImage
                })
            })
        ]
    }));
};

// EXTERNAL MODULE: ../../packages/hooks/src/index.ts + 10 modules
var hooks_src = __webpack_require__(39655);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Column/index.tsx
var Column = __webpack_require__(3735);
// EXTERNAL MODULE: ../../packages/uikit/src/components/Row/Row.tsx
var Row = __webpack_require__(92372);
;// CONCATENATED MODULE: ../../packages/uikit/src/widgets/Swap/SwapInfo.tsx





var SwapInfoLabel = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, (0,_object_spread/* default */.Z)({
        fontSize: "12px",
        bold: true,
        color: "secondary"
    }, props));
};
var SwapInfo = function(param) {
    var allowedSlippage = param.allowedSlippage, price = param.price;
    var t = (0,src/* useTranslation */.$G)().t;
    var isMounted = (0,hooks_src/* useIsMounted */.tm)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Column/* AutoColumn */.Tz, {
        gap: "sm",
        py: "0",
        px: "16px",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* RowBetween */.m0, {
                alignItems: "center",
                children: price
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* RowBetween */.m0, {
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SwapInfoLabel, {
                        children: t("Slippage Tolerance")
                    }),
                    isMounted && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                        bold: true,
                        color: "primary",
                        children: [
                            allowedSlippage / 100,
                            "%"
                        ]
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ../../packages/uikit/src/components/Svg/Icons/AutoRenew.tsx
var AutoRenew = __webpack_require__(73685);
;// CONCATENATED MODULE: ../../packages/uikit/src/widgets/Swap/TradePrice.tsx





function TradePrice(param) {
    var price = param.price;
    var ref, ref1, ref2, ref3, ref4;
    var ref5 = (0,react.useState)(false), showInverted = ref5[0], setShowInverted = ref5[1];
    var formattedPrice = showInverted ? price === null || price === void 0 ? void 0 : price.toSignificant(6) : (ref = price === null || price === void 0 ? void 0 : price.invert()) === null || ref === void 0 ? void 0 : ref.toSignificant(6);
    var show = Boolean((price === null || price === void 0 ? void 0 : price.baseCurrency) && (price === null || price === void 0 ? void 0 : price.quoteCurrency));
    var label = showInverted ? "".concat(price === null || price === void 0 ? void 0 : (ref1 = price.quoteCurrency) === null || ref1 === void 0 ? void 0 : ref1.symbol, " per ").concat(price === null || price === void 0 ? void 0 : (ref2 = price.baseCurrency) === null || ref2 === void 0 ? void 0 : ref2.symbol) : "".concat(price === null || price === void 0 ? void 0 : (ref3 = price.baseCurrency) === null || ref3 === void 0 ? void 0 : ref3.symbol, " per ").concat(price === null || price === void 0 ? void 0 : (ref4 = price.quoteCurrency) === null || ref4 === void 0 ? void 0 : ref4.symbol);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
        style: {
            justifyContent: "center",
            alignItems: "center",
            display: "flex"
        },
        children: show ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                formattedPrice !== null && formattedPrice !== void 0 ? formattedPrice : "-",
                " ",
                label,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AtomBox/* AtomBox */.p, {
                    className: SwapWidget_css/* balanceMaxMiniClass */.y2,
                    onClick: function() {
                        return setShowInverted(!showInverted);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AutoRenew/* default */.Z, {
                        width: "14px"
                    })
                })
            ]
        }) : "-"
    });
}

;// CONCATENATED MODULE: ../../packages/uikit/src/widgets/Swap/SwapWidget.tsx












var SwapSwitchButton = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(IconButton/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: SwapWidget_css/* switchButtonClass */.ZQ,
        variant: "light",
        scale: "sm"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDown/* default */.Z, {
                className: SwapWidget_css/* iconDownClass */.VO,
                color: "primary"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowUpDown/* default */.Z, {
                className: SwapWidget_css/* iconUpDownClass */.AG,
                color: "primary"
            })
        ]
    }));
};
var Swap = {
    SwitchButton: SwapSwitchButton,
    CurrencyInputHeaderTitle: CurrencyInputHeaderTitle,
    CurrencyInputHeaderSubTitle: CurrencyInputHeaderSubTitle,
    CurrencyInputHeader: CurrencyInputHeader,
    CurrencyInputPanel: CurrencyInputPanel,
    Page: SwapPage,
    Footer: SwapFooter,
    Info: SwapInfo,
    InfoLabel: SwapInfoLabel,
    TradePrice: TradePrice
};



/***/ })

}]);